var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingcomGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.865 22.653L12.6075 22.656C14.4585 22.656 15.606 21.492 15.606 19.5255C15.606 17.61 14.4285 16.428 12.6075 16.428H10.0545C9.237 16.545 8.865 17.058 8.865 18.042V22.653ZM8.865 9.00748V12.8805H12.2325C14.124 12.8805 14.799 11.373 14.799 10.083C14.799 8.38798 13.815 7.37548 12.174 7.37548H10.257C9.3015 7.44148 8.865 7.94548 8.865 9.00748ZM16.71 14.43L17.385 14.823C19.0275 15.7755 20.004 17.6475 20.004 19.8375C20.004 23.907 16.9815 26.5335 12.2985 26.5335H4.5855V6.00748C4.5975 4.71298 5.598 3.66598 6.8475 3.61798H7.395V3.61948H12.2025C16.4175 3.61948 19.1385 5.95348 19.1385 9.56998C19.1385 11.9325 17.988 13.302 17.2995 13.911L16.7085 14.43H16.71ZM24.753 20.862C23.241 20.862 22.0125 22.1295 22.0125 23.697C22.0125 25.2645 23.2395 26.535 24.753 26.535C26.268 26.535 27.501 25.2645 27.501 23.6985C27.501 22.1295 26.268 20.862 24.753 20.862Z",
    fill: "#FBFDFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingcomGrayIcon);
export default __webpack_public_path__ + "static/media/bookingcom-gray-icon.0595f1e7bd51e253c98175fbd37fb2ff.svg";
export { ForwardRef as ReactComponent };